export function assert(arg, message) {
    if (!arg) {
        throw new Error(message);
    }
}
